import React, { useEffect, useState } from 'react';

const AVATAR_BG = '#2889a6';

const getInitials = name => {
  if (!name || typeof name !== 'string') return '';
  const words = name.trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '';
  if (words.length === 1) return words[0][0].toUpperCase();
  return (words[0][0] + words[words.length - 1][0]).toUpperCase();
};

const Avatar = ({ name, src, alt = 'Avatar', style, imgStyle, fontSize = '16px' }) => {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [src]);

  if (src && !imgError) {
    return (
      <img
        src={src}
        alt={alt}
        onError={() => setImgError(true)}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '50%',
          display: 'block',
          ...style,
          ...imgStyle
        }}
      />
    );
  }

  const initials = getInitials(name);
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        borderRadius: '50%',
        background: AVATAR_BG,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        fontWeight: 800,
        fontSize,
        userSelect: 'none',
        ...style
      }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
